/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import colors from '@sportninja/common/constants/appColors'

/**
 * Main container styles for the registration preview page
 */
export const Container = css`
  overflow-y: scroll;
  background-color: ${colors.NEUTRAL_900};
  z-index: 100;
  height: 100vh;
`

/**
 * Background image wrapper styles
 * @param backgroundImageUrl - URL of the background image
 */
export const createBgImageWrapper = (backgroundImageUrl: string) => css`
  background-image: url(${backgroundImageUrl});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 40vh;
  z-index: 1;
`

/**
 * Hidden image styles for error handling
 */
export const HiddenImage = css`
  display: none;
`

/**
 * Content box styles for the main content area
 */
export const ContentBox = css`
  display: flex;
  flex-direction: column;
  max-width: 1080px;
  width: 100%;
  margin: 0 auto;
  background-color: ${colors.NEUTRAL_800};
  padding: 32px 35px 35px 35px;
  border-radius: 16px 16px 0px 0px;
  gap: 24px;
  @media (max-width: 768px) {
    padding: 24px 16px 35px 16px;
    max-width: 100%;
  }
  z-index: 200;
  position: relative;
  margin-top: 20vh;
`

/**
 * Global styles that need to be injected into the document
 */
export const globalStyles = `
  body.keyboard {
    height: calc(100% + 500px);
  }
  input {
    font-size: 16px !important;
  }
`
